// extracted by mini-css-extract-plugin
export default {"stopImpersonatingButton":"src-modules-impersonation-notification-style__stopImpersonatingButton_pjt8Z"};